document.addEventListener("dragstart", function(event) {
    if (event.target.tagName === "IMG") {
        event.preventDefault();
    }
});

// Dodatkowo blokowanie zapisywania obrazów przez kliknięcie prawym przyciskiem
document.addEventListener("contextmenu", function(event) {
    if (event.target.tagName === "IMG") {
        event.preventDefault();
    }
});
